module.exports = __webpack_public_path__ + "h5/img/poster.bdebebac.png";